module.exports = __webpack_public_path__ + "img/mobile-31.e0fe428b.png";